export default __webpack_public_path__ + "static/media/DNo.5-4.accda104.jpg";